export const LOAD_ASSETS_PENDING = 'LOAD_ASSETS_PENDING'
export const LOAD_ASSETS_SUCCESS = 'LOAD_ASSETS_SUCCESS'
export const LOAD_ASSETS_ERROR = 'LOAD_ASSETS_ERROR'
export const ASSET_LOADED = 'ASSET_LOADED'



// WEBPACK FOOTER //
// ./src/containers/Engine/containers/AssetLoader/actionTypes.js